import {Settings} from '../Settings';
import {$window, $body} from '../Constants';
import HtmlElement from './HtmlElement';


/**
 * ShortcutsBar
 */
const ShortcutsBar = (() => {
	// Constants
	const DATA_KEY = 'ig.shortcuts-bar';
	const EVENT_KEY = `.${DATA_KEY}`;

	/**
	 * Selector
	 */
	const Selector = {
		SHORTCUTS_BAR: '.shortcuts-bar'
	};

	/**
	 * Event
	 */
	const Event = {
		RESIZE: `resize${EVENT_KEY}`
	};

	/**
	 * ShortcutsBar
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class ShortcutsBar extends HtmlElement {
		/**
		 * @constructor
		 *
		 * @param { jQuery } $element
		 */
		constructor($element) {
			super($element);

			this._prevHeight = 0;
		}

		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this._adjustBodyIndent();
			this._bindHandlers();
		}

		// Private

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			$window.on(Event.RESIZE, () => {
				this._adjustBodyIndent();
			});
		}

		/**
		 * Sets the padding-bottom of the <body> to the height of the shortcuts bar
		 *
		 * @return void
		 */
		_adjustBodyIndent() {
			const newHeight = this.getHeight();

			if (this._prevHeight !== newHeight) {
				this._prevHeight = newHeight;
				$body.css('padding-bottom', newHeight);
			}
		}
	}

	return ShortcutsBar._getElement($body.find(Selector.SHORTCUTS_BAR), ShortcutsBar);
})();

export default ShortcutsBar;
